// LIBRARIES
import { createSlice } from "@reduxjs/toolkit";
import {
  getAllCategories,
  getCategorySubcategories,
  getSubcategoryArticles,
} from "api/supportApi";
import { IArticle, ICategory, ISubcategory } from "models/interfaces";

export interface ISupportInitialState {
  categories: ICategory[];
  subcategories: ISubcategory[];
  articles: IArticle[];
  isLoading: boolean;
  errorMessage: string;
}

const initialState: ISupportInitialState = {
  categories: [],
  subcategories: [],
  articles: [],
  isLoading: true,
  errorMessage: "",
};

export const supportSlice = createSlice({
  name: "support",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllCategories.pending, (state) => {
      state.isLoading = true;
      state.errorMessage = "";
    });
    builder.addCase(getAllCategories.fulfilled, (state, action) => {
      state.isLoading = false;
      state.categories = action.payload.data;
    });
    builder.addCase(getAllCategories.rejected, (state, action) => {
      state.isLoading = false;
      state.errorMessage = action.error.message;
      state.categories = null;
    });
    builder.addCase(getCategorySubcategories.pending, (state) => {
      state.isLoading = true;
      state.errorMessage = "";
    });
    builder.addCase(getCategorySubcategories.fulfilled, (state, action) => {
      state.isLoading = false;
      state.subcategories = action.payload.data;
    });
    builder.addCase(getCategorySubcategories.rejected, (state, action) => {
      state.isLoading = false;
      state.errorMessage = action.error.message;
      state.subcategories = null;
    });
    builder.addCase(getSubcategoryArticles.pending, (state) => {
      state.isLoading = true;
      state.errorMessage = "";
    });
    builder.addCase(getSubcategoryArticles.fulfilled, (state, action) => {
      state.isLoading = false;
      state.articles = action.payload.data;
    });
    builder.addCase(getSubcategoryArticles.rejected, (state, action) => {
      state.isLoading = false;
      state.errorMessage = action.error.message;
      state.articles = null;
    });
  },
});

//eslint-disable-next-line
export const {} = supportSlice.actions;

export const categories = (state) => state.support.categories;
export const subcategories = (state) => state.support.subcategories;
export const articles = (state) => state.support.articles;

export default supportSlice.reducer;
